import { TextFieldHelper } from "@goodgamestudios/core";
import { TimeStringHelper } from "@goodgamestudios/core";
import { Poker2Constants } from "../../../constants/Poker2Constants";
import { Poker2ShopEvent } from "../../../event/Poker2ShopEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2StarterPackageTeaserDialogProperties } from "./Poker2StarterPackageTeaserDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2StarterPackageTeaserDialog extends Poker2Dialog {
    public static NAME: string = "Poker2StarterPackageTeaserDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.dialogTemplate.txt_title.text = Poker2Model.languageData.getTextById("dialog_bundleteaser_title");
        this.dialogTemplate.txt_copy.text = Poker2Model.languageData.getTextById("dialog_bundleteaser_copy");

        // time left
        TextFieldHelper.changeTextFromatSizeByTextWidth(24, this.dialogTemplate.txt_time, Poker2Model.languageData.getTextById("generic_payment_discount_time", [TimeStringHelper.getTimeToString(this.dialogProperties.timeleft, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData))]));

        // btn shop
        this.dialogTemplate.btn_shop.label = Poker2Model.languageData.getTextById("generic_payment_btn");
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.dialogTemplate.btn_close:

                this.hide();
                break;

            case this.dialogTemplate.btn_shop:

                // jump to shop
                Poker2LayoutManager.getInstance().state = 12;

                // jump to the starter packages category within the shop
                this.controller.dispatchEvent(new Poker2ShopEvent("changeCategory", ["starterPackages"]));

                this.hide();
                break;
        }
    }

    private get dialogProperties(): Poker2StarterPackageTeaserDialogProperties {
        return this.properties as Poker2StarterPackageTeaserDialogProperties;
    }

    private get dialogTemplate(): Library.PokerStarterPackages.PokerStarterPackageTeaser {
        return this.disp as Library.PokerStarterPackages.PokerStarterPackageTeaser;
    }
}
import { Poker2LayoutManager } from "../../Poker2LayoutManager";
